(() => {
  if (window.customerVideosReady) return;
  window.customerVideosReady = true;

  const selector = '[data-customer-videos]';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setCardState = (card, isPlaying) => {
    card.classList.toggle('is-playing', isPlaying);
  };

  const setButtonState = (button, isPlaying) => {
    button.setAttribute('aria-pressed', String(isPlaying));
    button.setAttribute(
      'aria-label',
      isPlaying ? button.dataset.labelPause : button.dataset.labelPlay
    );
    const card = button.closest('[data-video-card]');
    if (card) setCardState(card, isPlaying);
  };

  const pauseVideo = (video, button) => {
    video.pause();
    setButtonState(button, false);
  };

  const playVideo = (video, button, { unmute = false } = {}) => {
    if (unmute) video.muted = false;

    video.play()
      .then(() => setButtonState(button, true))
      .catch(() => setButtonState(button, false));
  };

  const initCustomerVideos = (root) => {
    if (root.dataset.customerVideosReady === 'true') return;
    root.dataset.customerVideosReady = 'true';
    root.classList.add('customer-videos-wrapper--enhanced');

    const cards = root.querySelectorAll('[data-video-card]');

    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const card = entry.target;
            const video = card.querySelector('[data-video-player]');
            const button = card.querySelector('[data-video-toggle]');

            if (!video || !button) return;

            if (!entry.isIntersecting && !video.paused) {
              pauseVideo(video, button);
              return;
            }

            if (
              entry.isIntersecting &&
              video.hasAttribute('data-autoplay') &&
              video.paused &&
              !prefersReducedMotion.matches
            ) {
              playVideo(video, button);
            }
          });
        }, { threshold: 0.5 })
      : null;

    cards.forEach((card) => {
      const video = card.querySelector('[data-video-player]');
      const button = card.querySelector('[data-video-toggle]');

      if (!video || !button) return;

      video.controls = false;
      setButtonState(button, false);

      button.addEventListener('click', () => {
        if (video.paused) {
          playVideo(video, button, { unmute: true });
        } else {
          pauseVideo(video, button);
        }
      });

      video.addEventListener('play', () => setButtonState(button, true));
      video.addEventListener('pause', () => setButtonState(button, false));
      video.addEventListener('ended', () => setButtonState(button, false));

      if (observer) observer.observe(card);
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(selector).forEach(initCustomerVideos);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  }
})();
